interface TimeObj {
  hour: string;
  minute: string;
  meridian: string;
}

export function timeObjToString(timeObj: TimeObj): string {
  if(timeObj.hour == "00" && timeObj.minute == "00" && timeObj.meridian == "AM" ){
    return "";
  }
  const timeString = `${timeObj?.hour}:${timeObj?.minute }:${timeObj?.meridian}`;
  return timeString;
}
export function stringToTimeObj(timeString: string): TimeObj | null {
  if (!timeString) return null;
  const split = timeString.replace(' ', ':').split(':');
  return {
    hour: split[0],
    minute: split[1],
    meridian: split[2],
  };
}
